import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, concatWith } from 'rxjs';

import { AcaoConcurso } from '@app/core/models/acao-concurso';
import { BotaoAcaoConcursoComponent } from '@app/shared/botao-acao-concurso/botao-acao-concurso.component';
import { Concurso } from '@core/models/concurso';
import { FiltroConcurso } from '../tabela-concurso/filtro';
import { Injectable } from '@angular/core';
import { SituacaoConcurso } from './../../core/models/perfil-profissiografico/situacao-concurso';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'any'
})
export class ConcursoApiService {
	constructor(private http: HttpClient) {}
	filtro = new FiltroConcurso();

	URL_CONCURSO = environment.HOST_OPORTUNIDADE + '/' + 'concurso';

	situacoes$?: Observable<SituacaoConcurso[]>;

	obterConcursos(concurso: Concurso, pagina?: number, tamanho?: number): Observable<any[]> {
		let params = new HttpParams();

		console.log(concurso);
		if (concurso.nome) {
			params = params.set('nome', concurso.nome);
		}

		if (concurso.codigo) {
			params = params.set('codigo', concurso.codigo);
		}

		if (concurso.situacao) {
			params = params.set('situacao', concurso.situacao);
		}

		if (concurso.orientacao) {
			params = params.set('orientacao', concurso.orientacao);
		}

		if (concurso.utiliza_perfil) {
			params = params.set('utiliza_perfil', 1);
		}

		if (pagina) {
			params = params.set('page', pagina);
		}

		if (tamanho) {
			params = params.set('size', tamanho);
		}

		return this.http.get<any[]>(this.URL_CONCURSO, { params: params });
	}

	obterConcurso(id: number): Observable<Concurso> {
		const url = this.URL_CONCURSO + '/' + id.toString();
		return this.http.get<Concurso>(url);
	}

	incluirConcurso(concurso: Concurso) {
		if (concurso.orientacao == undefined) {
			concurso.orientacao = '';
		}
		return this.http.post(this.URL_CONCURSO, concurso);
	}

	alterarConcurso(id: number, concurso: Concurso) {
		if (concurso.orientacao == undefined) {
			concurso.orientacao = '';
		}
		const url = this.URL_CONCURSO + '/' + id.toString();
		return this.http.put(url, concurso);
	}

	excluirConcurso(id: number) {
		const url = this.URL_CONCURSO + '/' + id.toString();
		return this.http.delete(url);
	}

	executarAcao(id: number, acao: AcaoConcurso) {
		const url = this.URL_CONCURSO + '/' + id.toString() + '/execucao-acao?codigo_acao=' + acao.codigo_acao?.toString();
		return this.http.post(url, acao);
	}

	listarSituacoes(): void {
		const url = this.URL_CONCURSO + '/situacao';
		this.situacoes$ = this.http.get<SituacaoConcurso[]>(url);
	}
}
